import Skeleton from "react-loading-skeleton";

export const QuerySuggestionSkeleton = ({ count = 5 }) => {
  return (
    <ul style={{ height: "auto" }}>
      {Array.from({ length: count }).map((_, i) => (
        <li key={1000 + i}>
          <a>
            <span className="wes-search" />
            <Skeleton width={180} />
          </a>
        </li>
      ))}
    </ul>
  );
};
